// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const DownloadcircleMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_11967_42)">
            <path d="M10 5.83334V14.1667M10 14.1667L12.5 11.6667M10 14.1667L7.5 11.6667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.0003 18.3333C14.6027 18.3333 18.3337 14.6023 18.3337 9.99999C18.3337 5.39761 14.6027 1.66666 10.0003 1.66666C5.39795 1.66666 1.66699 5.39761 1.66699 9.99999C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_11967_42">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
